import { sportsCategoryConstants } from "../../constants";
import { sportCategoryService } from "../../services";
import { alertActions } from "../alert.actions";

export const sportCategoryActions = {
  getSingleParameter,
  getAllParameters,
  addParameter,
  updateParameter,
  deleteParameter,
  clear,
};

// get single parameter
function getSingleParameter() {}

// get all parameter
function getAllParameters() {
  return (dispatch) => {
    dispatch(request());

    sportCategoryService.getAllParameters().then(
      (items) => dispatch(success(items)),
      (error) => dispatch(failure(error))
    );
  };

  function request(params) {
    return { type: sportsCategoryConstants.GET_ALL_REQUEST, params };
  }
  function success(items) {
    return { type: sportsCategoryConstants.GET_ALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: sportsCategoryConstants.GET_ALL_FAILURE, error };
  }
}

// add parameter
function addParameter(name, status) {
  return (dispatch) => {
    dispatch(request(name, status));

    sportCategoryService.addParameter(name, status).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: sportsCategoryConstants.ADD_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: sportsCategoryConstants.ADD_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: sportsCategoryConstants.ADD_FAILURE, error };
  }
}

// update parameter
function updateParameter(id, name, status) {
  return (dispatch) => {
    dispatch(request(id, name, status));

    sportCategoryService.updateParameter(id, name, status).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: sportsCategoryConstants.UPDATE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: sportsCategoryConstants.UPDATE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: sportsCategoryConstants.UPDATE_FAILURE, error };
  }
}

// delete parameter
function deleteParameter(id) {
  return (dispatch) => {
    dispatch(request(id));

    sportCategoryService.deleteParameter(id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: sportsCategoryConstants.DELETE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: sportsCategoryConstants.DELETE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: sportsCategoryConstants.DELETE_FAILURE, error };
  }
}

// clear parameter
function clear() {
  return { type: sportsCategoryConstants.CLEAR };
}
